var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900.23 357.56",
    style: {
      enableBackground: "new 0 0 900.23 357.56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#B5E517;}\n\t.st2{fill:#003C32;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,125.83h112.35c25.91,0,38.98,10.32,38.98,31.18v13.3c0,12.84-5.04,21.78-14.9,26.6 c11.46,4.59,17.2,13.99,17.2,27.74v21.32c0,20.86-13.07,31.18-38.98,31.18H0V125.83z M97.45,184.3c5.27,0,8.03-2.06,8.03-6.42 v-18.11c0-4.36-2.75-6.42-8.03-6.42H45.86v30.95H97.45z M99.74,249.64c5.27,0,8.03-2.06,8.03-6.42v-24.99 c0-4.36-2.75-6.42-8.03-6.42H45.86v37.83H99.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M183.44,125.83h112.35c25.91,0,38.98,10.32,38.98,31.18v31.64c0,18.8-10.55,28.66-30.95,31.18l37.83,57.32 h-49.53l-37.83-57.32h-24.99v57.32h-45.86V125.83z M280.88,192.32c5.27,0,8.03-2.06,8.03-6.42v-26.14c0-4.36-2.75-6.42-8.03-6.42 h-51.59v38.98H280.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M549.41,125.83h49.3l65.35,90.8v-90.8h45.86v151.33h-49.3l-65.35-90.8v90.8h-45.86V125.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M742.02,125.83h80.25c52.05,0,77.96,20.86,77.96,62.37v26.6c0,41.5-25.91,62.37-77.96,62.37h-80.25V125.83z  M813.1,249.64c27.51,0,41.27-11,41.27-33.02v-30.27c0-22.01-13.76-33.02-41.27-33.02h-25.22v96.3H813.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.89,356.85h-9.02l-23.13-36.82v36.82h-9.02v-51.9h9.02l23.21,36.96v-36.96h8.95V356.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M342.05,344.77h-20.1l-4.21,12.08h-9.38l19.61-51.9h8.09l19.64,51.9h-9.41L342.05,344.77z M324.47,337.5 h15.04l-7.52-21.53L324.47,337.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M438.6,312.22h-16.18v44.63h-8.95v-44.63h-16.04v-7.27h41.17V312.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.73,356.85h-8.98v-51.9h8.98V356.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M595.03,332.26c0,5.09-0.88,9.55-2.64,13.38c-1.76,3.84-4.27,6.78-7.54,8.84c-3.27,2.06-7.03,3.08-11.28,3.08 c-4.21,0-7.95-1.03-11.25-3.08c-3.29-2.06-5.83-4.98-7.63-8.79c-1.79-3.8-2.7-8.19-2.73-13.15v-2.92c0-5.06,0.9-9.53,2.69-13.4 c1.79-3.87,4.32-6.84,7.59-8.89c3.27-2.06,7.02-3.08,11.25-3.08s7.98,1.02,11.25,3.05c3.27,2.03,5.79,4.95,7.57,8.77 c1.78,3.81,2.68,8.25,2.71,13.31V332.26z M586.01,329.55c0-5.75-1.09-10.16-3.26-13.23c-2.17-3.07-5.26-4.6-9.25-4.6 c-3.9,0-6.95,1.53-9.14,4.58c-2.2,3.05-3.32,7.37-3.37,12.96v2.99c0,5.7,1.11,10.11,3.33,13.22c2.22,3.11,5.31,4.67,9.25,4.67 c3.99,0,7.06-1.52,9.22-4.56c2.15-3.04,3.23-7.48,3.23-13.33V329.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M688.99,356.85h-9.02l-23.13-36.82v36.82h-9.02v-51.9h9.02l23.21,36.96v-36.96h8.95V356.85z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 728.85,
    y: 326.73,
    className: "st1",
    width: 171.38,
    height: 10.76
  }), /*#__PURE__*/React.createElement("rect", {
    y: 326.73,
    className: "st1",
    width: 171.38,
    height: 10.76
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "443.68,0 427.79,46.85 427.79,46.85 406.3,110.22 404.17,116.49 404.17,116.49 393.78,147.13  393.78,147.13 349.68,277.16 394.62,277.16 443.68,125.29 492.75,277.16 537.69,277.16  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.71b18a1fea254c79e934345baa096835.svg";
export { ForwardRef as ReactComponent };